import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { allPages } from '~/routes';

const defaultDocumentTitle = 'Accurate';

export function useDocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    const routePath = Object.keys(allPages).find((path) =>
      matchPath(location.pathname, { exact: true, path, strict: true })
    );

    const route = allPages[routePath];
    if (route) {
      document.title = route.documentTitle || defaultDocumentTitle;
    }

    return () => {
      document.title = defaultDocumentTitle;
    };
  }, [location.pathname]);
}
